
import {share} from 'rxjs/operators';
import { HttpService } from "../http/http.service";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class InternetService {

    public get headers(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });
    }

    constructor(private httpService: HttpService) {}

    /**
     * Realiza requisições HTTP GET
     *
     * @param url endereço HTTP a ser requisitado
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    get<T>(url: string, headers?: HttpHeaders): Observable<T> {
        return this.httpService.get<T>(url, headers? headers : this.headers).pipe(share());
    }

    /**
     * Realiza requisições HTTP POST
     *
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    post<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpService.post<T>(url, payload, headers? headers : this.headers).pipe(share());
    }

    /**
     * Realiza requisições HTTP PATCH
     *
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    patch<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpService.patch<T>(url, payload, headers? headers : this.headers).pipe(share());
    }

    /**
     * Realiza requisições HTTP DELETE
     *
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    delete<T>(url: string,headers?: HttpHeaders): Observable<T> {
        return this.httpService.delete<T>(url, headers? headers : this.headers).pipe(share());
    }

    /**
     * Realiza requisições HTTP PUT
     *
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    put<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpService.put<T>(url, payload, headers? headers : this.headers).pipe(share());
    }

}
